<template>
  <v-row justify="center" align="stretch" dense>
    <v-col cols="12" lg="4">
      <Lottie
        :podcast2="true"
        data-aos="fade-up"
        data-aos-easing="ease"
        data-aos-duration="1000"
        data-aos-once="true"
      />
      <audio
        controls
        style="width: 100%; background-color: #f2f2f2; border-radius: 4px"
      >
        <source src="@/assets/modulo_01/podcasts/audio_1.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <v-btn
        block
        color="primary"
        depressed
        class="white--text"
        @click="showTranscription = !showTranscription"
      >
        <div>Visualizar transcrição</div>
      </v-btn>
    </v-col>

    <v-col cols="12" lg="8" v-if="showTranscription" class="pt-0 pb-0 pr-0 pl-1">
      <TextBlock style="height: 100%;">
        <Paragraph
          class="px-8 py-7 rounded-lg"
          style="overflow: auto; height: 100%; background: white; color: #333;"
        >
        Você sabia que esses documentos podem ser digitais? Sim, tanto a CNH quanto o CRLV têm versões digitais oficiais. Em caso de fiscalização, você pode apresentá-los diretamente no seu celular, desde que esteja com a bateria carregada. Mas fique atento! <strong>Se você for pego sem qualquer um desses documentos, as consequências podem incluir multas, apreensão do veículo e outros problemas indesejados.</strong> Então, lembre-se de verificar sua documentação antes de pegar o volante para evitar dores de cabeça e garantir uma condução tranquila e sem contratempos.
        </Paragraph>
      </TextBlock>
    </v-col>
  </v-row>
</template>

<script>
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";
import Lottie from "@/components/Lottie.vue";

export default {
  components: {
    TextBlock,
    Paragraph,
    Lottie,
  },
  data() {
    return {
      showTranscription: false,
    };
  },

  methods: {},
};
</script>

<style scoped></style>
